import Vue from 'vue';
import CountryFlag from 'vue-country-flag';
import Spinner from './shared/Spinner.vue';
import ImageReel from './shared/ImageReel.vue';
import DataTable from './shared/DataTable.vue';
import StandardEntry from './shared/StandardEntry.vue';

Vue.component('StandardEntry', StandardEntry);
Vue.component('spinner', Spinner);
Vue.component('image-reel', ImageReel);
Vue.component('country-flag', CountryFlag);
Vue.component('data-table', DataTable);
